import axiosInstance from '../services/axios-instance'
import type {
  LoginMutation,
  RegisterMutation,
  CreateAlunoMutation,
  CreateEnderecoMutation,
  CreateDocenteMutation,
  CreateUnidadeCurricularMutation,
  CreateProjetoMutation,
  CreateDisciplinaMutation,
  CreateDisciplinaProjetoMutation,
  CreateProjetoAlunoMutation,
  CreateProjetoDocenteMutation,
  CreateEtapaProjetoMutation,
  CreateAnexoEtapaMutation
} from '../types/types-mutations'

const getAuthHeaders = () => {
  const token = localStorage.getItem('accessTokenIntegrado')
  return {
    Authorization: `Bearer ${token}`
  }
}

export async function Login(payload: LoginMutation) {
  const response = await axiosInstance.post('/api/user/login', payload, {})
  return response.data
}

export async function Register(payload: RegisterMutation) {
  const response = await axiosInstance.post('/api/user/auth/register', payload, {})
  return response.data
}

// Aluno
export async function createAluno(payload: CreateAlunoMutation) {
  const response = await axiosInstance.post(
    '/api/v1/senai/alunos/create',
    payload,
    {
      headers: getAuthHeaders()
    }
  )
  return response.data
}

// Endereço
export async function createEndereco(payload: CreateEnderecoMutation) {
  const response = await axiosInstance.post(
    '/api/v1/senai/endereco/create',
    payload
  )
  return response.data
}

// Docente
export async function createDocente(payload: CreateDocenteMutation) {
  const response = await axiosInstance.post(
    '/api/v1/senai/docente/create',
    payload,
    {
      headers: getAuthHeaders()
    }
  )
  return response.data
}

// Unidade Curricular
export async function createUnidadeCurricular(
  payload: CreateUnidadeCurricularMutation
) {
  const response = await axiosInstance.post(
    '/api/v1/senai/unidadeCurricular/create',
    payload,
    {
      headers: getAuthHeaders()
    }
  )
  return response.data
}

// Projeto
export async function createProjeto(payload: CreateProjetoMutation) {
  const response = await axiosInstance.post(
    '/api/v1/senai/disciplina/create',
    payload,
    {
      headers: getAuthHeaders()
    }
  )
  return response.data
}

// Disciplina
export async function createDisciplina(payload: CreateDisciplinaMutation) {
  const response = await axiosInstance.post(
    '/api/v1/senai/disciplina/create',
    payload,
    {
      headers: getAuthHeaders()
    }
  )
  return response.data
}

// Disciplina Projeto
export async function createDisciplinaProjeto(
  payload: CreateDisciplinaProjetoMutation
) {
  const response = await axiosInstance.post(
    '/api/v1/senai/disciplinaProjeto/create',
    payload,
    {
      headers: getAuthHeaders()
    }
  )
  return response.data
}

// Projeto Aluno
export async function createProjetoAluno(payload: CreateProjetoAlunoMutation) {
  const response = await axiosInstance.post(
    '/api/v1/senai/projetoAluno/create',
    payload,
    {
      headers: getAuthHeaders()
    }
  )
  return response.data
}

// Projeto Docente
export async function createProjetoDocente(
  payload: CreateProjetoDocenteMutation
) {
  const response = await axiosInstance.post(
    '/api/v1/senai/projetoDocente/create',
    payload,
    {
      headers: getAuthHeaders()
    }
  )
  return response.data
}

// Etapa Projeto - CREATE
export async function createEtapaProjeto(payload: CreateEtapaProjetoMutation) {
  const response = await axiosInstance.post(
    '/api/v1/senai/etapasProjeto/create',
    payload,
    {
      headers: getAuthHeaders()
    }
  )
  return response.data
}

// Etapa Projeto - UPDATE
export async function updateEtapaProjeto(uuid: string, payload: CreateEtapaProjetoMutation) {
  const response = await axiosInstance.put(
    `/api/v1/senai/etapasProjeto/update/${uuid}`,
    payload,
    {
      headers: getAuthHeaders()
    }
  )
  return response.data
}

// Etapa Projeto - DELETE
export async function deleteEtapaProjeto(uuid: string) {
  const response = await axiosInstance.delete(
    `/api/v1/senai/etapasProjeto/delete/${uuid}`,
    {
      headers: getAuthHeaders()
    }
  )
  return response.data
}

// Anexo Etapa
export async function createAnexoEtapa(payload: CreateAnexoEtapaMutation) {
  const response = await axiosInstance.post(
    '/api/v1/senai/AnexoEtapa/create',
    payload,
    {
      headers: getAuthHeaders()
    }
  )
  return response.data
}
